import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import FreeProducts from 'merchandise-lib/constants/FreeProduct';
import { MerchCardColumns } from 'pricing-pages-ui-components/components/MerchCardColumns';
import { overrideStarterApiNames } from '../../../hooks/upsell/useStarterUpsell';
import { BaseCardBadge } from '../../components/merch-card/BaseCardBadge';
import { FREE_CARD } from '../../constants/tracking/TrackingSources';
import { useBadges } from '../../hooks/badges/useBadges';
import { useShowUpsellCustomerPlatformMerchCard } from '../../hooks/product/useUpsellCustomerPlatformMerchCard';
import { FreeToolsMerchCard } from './cards/FreeToolsMerchCard';
import { HubMerchCard } from './cards/HubMerchCard';
import { UpsellCustomerPlatformMerchCard } from './cards/customer-platform/UpsellCustomerPlatformMerchCard';
import { PriorityFeaturesByProductApiName } from './features-display/PriorityFeaturesByProductApiName';
import { MerchCardTitleContainer } from './headings-display/MerchCardTitleContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const HubMerchCardLayoutUI = ({
  productsConfig,
  screen
}) => {
  var _productsConfig$START, _badges$upsellApiName, _badges, _productsConfig$START2, _badges$professionalA, _productsConfig$PROFE, _badges$enterpriseApi, _productsConfig$ENTER;
  const {
    showUpsell,
    upsellApiName,
    loading
  } = useShowUpsellCustomerPlatformMerchCard();
  const hasFree = !!productsConfig.FREE;
  const hasStarter = !!productsConfig.STARTER;
  const starterApiName = (_productsConfig$START = productsConfig.STARTER) === null || _productsConfig$START === void 0 ? void 0 : _productsConfig$START.apiName;
  const professionalApiName = productsConfig.PROFESSIONAL.apiName;
  const enterpriseApiName = productsConfig.ENTERPRISE.apiName;
  const apiNames = hasStarter && starterApiName ? [starterApiName, professionalApiName, enterpriseApiName] : [professionalApiName, enterpriseApiName];
  const apiNamesWithUpsell = hasStarter ? overrideStarterApiNames(apiNames, showUpsell, upsellApiName) : apiNames;

  // Include Free product in badge check when present
  const allApiNames = hasFree ? [FreeProducts.HUBSPOT_FREE, ...apiNamesWithUpsell] : apiNamesWithUpsell;
  const {
    badges,
    hasBadgeOnFirstColumn,
    hasBadgeOnLastColumn
  } = useBadges({
    productApiNames: allApiNames,
    skipOverride: loading
  });
  const columnCount = (hasFree ? 1 : 0) + apiNamesWithUpsell.length;

  // Calculate column positions based on which tiers are present
  const hasBothFreeAndStarter = hasFree && hasStarter;
  const hasEitherFreeOrStarter = hasFree || hasStarter;
  const freeColumn = 1;
  const starterColumn = hasFree ? 2 : 1;
  const professionalColumn = hasBothFreeAndStarter ? 3 : hasEitherFreeOrStarter ? 2 : 1;
  const enterpriseColumn = hasBothFreeAndStarter ? 4 : hasEitherFreeOrStarter ? 3 : 2;
  return /*#__PURE__*/_jsx(View, {
    position: "relative",
    marginBlockEnd: "800",
    children: /*#__PURE__*/_jsxs(MerchCardColumns, {
      columns: columnCount,
      hasBadgeOnFirstColumn: hasBadgeOnFirstColumn,
      hasBadgeOnLastColumn: hasBadgeOnLastColumn,
      children: [hasFree && /*#__PURE__*/_jsx(FreeToolsMerchCard, {
        columnStart: freeColumn,
        Title: productsConfig.FREE.Title,
        HubDescription: productsConfig.FREE.HubDescription,
        Features: productsConfig.FREE.Features,
        trackingSource: FREE_CARD
      }), hasStarter && (showUpsell ? /*#__PURE__*/_jsx(UpsellCustomerPlatformMerchCard, {
        productApiName: upsellApiName,
        columnStart: starterColumn,
        hubPageStarterApiName: starterApiName,
        lowerTierMessage: productsConfig.STARTER.lowerTierMessage,
        Title: /*#__PURE__*/_jsx(MerchCardTitleContainer, {
          Title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricing-pages-ui.merchCardsV2.titleDisplay.starterCard"
          }),
          Badge: /*#__PURE__*/_jsx(BaseCardBadge, {
            apiName: upsellApiName,
            badgeName: badges === null || badges === void 0 || (_badges$upsellApiName = badges[upsellApiName]) === null || _badges$upsellApiName === void 0 ? void 0 : _badges$upsellApiName.badgeName
          })
        }),
        screen: screen
      }, upsellApiName) : /*#__PURE__*/_jsx(HubMerchCard, {
        apiName: starterApiName,
        columnStart: starterColumn,
        Subheading: productsConfig.STARTER.Subheading,
        Title: /*#__PURE__*/_jsx(MerchCardTitleContainer, {
          Title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricing-pages-ui.merchCardsV2.titleDisplay.starterCard"
          }),
          Badge: /*#__PURE__*/_jsx(BaseCardBadge, {
            apiName: starterApiName,
            badgeName: badges === null || badges === void 0 || (_badges = badges[starterApiName]) === null || _badges === void 0 ? void 0 : _badges.badgeName
          })
        }),
        Features: /*#__PURE__*/_jsx(PriorityFeaturesByProductApiName, {
          productApiName: starterApiName,
          lowerTierMessage: productsConfig.STARTER.lowerTierMessage
        }),
        screen: screen,
        skipInterstitial: (_productsConfig$START2 = productsConfig.STARTER) === null || _productsConfig$START2 === void 0 ? void 0 : _productsConfig$START2.skipInterstitial
      }, starterApiName)), /*#__PURE__*/_jsx(HubMerchCard, {
        apiName: professionalApiName,
        columnStart: professionalColumn,
        Subheading: productsConfig.PROFESSIONAL.Subheading,
        Title: /*#__PURE__*/_jsx(MerchCardTitleContainer, {
          Title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricing-pages-ui.merchCardsV2.titleDisplay.professionalCard"
          }),
          Badge: /*#__PURE__*/_jsx(BaseCardBadge, {
            apiName: professionalApiName,
            badgeName: badges === null || badges === void 0 || (_badges$professionalA = badges[professionalApiName]) === null || _badges$professionalA === void 0 ? void 0 : _badges$professionalA.badgeName
          })
        }),
        Features: /*#__PURE__*/_jsx(PriorityFeaturesByProductApiName, {
          productApiName: professionalApiName,
          lowerTierMessage: productsConfig.PROFESSIONAL.lowerTierMessage
        }),
        screen: screen,
        skipInterstitial: (_productsConfig$PROFE = productsConfig.PROFESSIONAL) === null || _productsConfig$PROFE === void 0 ? void 0 : _productsConfig$PROFE.skipInterstitial
      }, professionalApiName), /*#__PURE__*/_jsx(HubMerchCard, {
        apiName: enterpriseApiName,
        columnStart: enterpriseColumn,
        Subheading: productsConfig.ENTERPRISE.Subheading,
        Title: /*#__PURE__*/_jsx(MerchCardTitleContainer, {
          Title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricing-pages-ui.merchCardsV2.titleDisplay.enterpriseCard"
          }),
          Badge: /*#__PURE__*/_jsx(BaseCardBadge, {
            apiName: enterpriseApiName,
            badgeName: badges === null || badges === void 0 || (_badges$enterpriseApi = badges[enterpriseApiName]) === null || _badges$enterpriseApi === void 0 ? void 0 : _badges$enterpriseApi.badgeName
          })
        }),
        Features: /*#__PURE__*/_jsx(PriorityFeaturesByProductApiName, {
          productApiName: enterpriseApiName,
          lowerTierMessage: productsConfig.ENTERPRISE.lowerTierMessage
        }),
        screen: screen,
        skipInterstitial: (_productsConfig$ENTER = productsConfig.ENTERPRISE) === null || _productsConfig$ENTER === void 0 ? void 0 : _productsConfig$ENTER.skipInterstitial
      }, enterpriseApiName)]
    })
  });
};